import { gql } from '__generated__';

export default gql(`
  mutation AddParticipantFieldImport($input: AddParticipantFieldImportInput!) {
    addParticipantFieldImport(input: $input) {
      id
    }
  }
`);
